import { render, staticRenderFns } from "./JsonExcelWrapper.vue?vue&type=template&id=24fa5451&"
import script from "./JsonExcelWrapper.vue?vue&type=script&lang=js&"
export * from "./JsonExcelWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports